import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function GuidesPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <nav className="text-sm text-foreground-500 mb-6">
              <a href="/" className="hover:text-primary-600 transition-colors">Home</a>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">Guides</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">CSSBuy Guides</h1>
            <p className="text-foreground-600 text-lg">Comprehensive guides to help you navigate CSSBuy, shipping, QC, and more.</p>
          </div>
        </section>
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
            <a href="/cssbuy-spreadsheet" className="flex items-start gap-3 p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-colors">
              <i className="ri-table-line text-primary-500 text-lg mt-1"></i>
              <div>
                <h3 className="font-semibold text-foreground-900">CSSBuy Spreadsheet Guide</h3>
                <p className="text-sm text-foreground-600">Complete guide to using CSSBuy Spreadsheet</p>
              </div>
            </a>
            <a href="/shipping" className="flex items-start gap-3 p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-colors">
              <i className="ri-truck-line text-secondary-500 text-lg mt-1"></i>
              <div>
                <h3 className="font-semibold text-foreground-900">Shipping Guide</h3>
                <p className="text-sm text-foreground-600">Understand shipping costs and methods</p>
              </div>
            </a>
            <a href="/qc" className="flex items-start gap-3 p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-colors">
              <i className="ri-camera-lens-line text-accent-500 text-lg mt-1"></i>
              <div>
                <h3 className="font-semibold text-foreground-900">QC Guide</h3>
                <p className="text-sm text-foreground-600">How to read and understand QC photos</p>
              </div>
            </a>
            <a href="/safety" className="flex items-start gap-3 p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-colors">
              <i className="ri-shield-check-line text-accent-500 text-lg mt-1"></i>
              <div>
                <h3 className="font-semibold text-foreground-900">Safety Center</h3>
                <p className="text-sm text-foreground-600">Stay safe when buying and researching</p>
              </div>
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}